import {
    replace,
    trim,
    compose,
    split,
    take,
    toLower,
    dropLastWhile
} from 'ramda';

import { withSortLocale, joinWithDashes, replaceSlashDash } from '../v5/OptimizedSearch/Engine/SharedRules';

// eslint-disable-next-line
const oneregex = /(\/)?search(\/bodystyles-\w*)?(\/geo-[\w-]*)?(((?!colors-)\/[\w-]*)\/((?!colors-)(?!geo-)[\w-]*))?(\/[0-9]{4})?(\/(?!colors-)(?!geo-)[\w-]*)?((\/colors-\w*)*)?(\/geo-[\w-]*)?((\/colors-\w*)*)?(\?.*)?$/;

const expectedLength = 15;
const knownMakes = [
    'Acura',
    'Alfa Romeo',
    'Audi',
    'BMW',
    'Buick',
    'Cadillac',
    'Chevrolet',
    'Chrysler',
    'Dodge',
    'FIAT',
    'Ford',
    'Genesis',
    'GMC',
    'Honda',
    'Hyundai',
    'INFINITI',
    'Jaguar',
    'Jeep',
    'Kia',
    'Land Rover',
    'Lexus',
    'Lincoln',
    'Maserati',
    'Mazda',
    'Mercedes-Benz',
    'MINI',
    'Mitsubishi',
    'Nissan',
    'Pontiac',
    'Porsche',
    'Ram',
    'Scion',
    'smart',
    'Subaru',
    'Tesla',
    'Toyota',
    'Volkswagen',
    'Volvo'
    ];

const fixColors = compose(split(' '), trim, replace(/\/colors-/g, ' '));
const fixBodystyles = compose(replace(/pickup/g, 'truck'), replace(/\/bodystyles-/g, ''));
const fixUrl = compose(dropLastWhile(x=>/[/-]/.test(x)) , trim, replaceSlashDash, replace(/geo-/g, 'in-'), replace(/_/g, '-'));
const fastNormalize = compose(trim, replace(/\/colors-other/, ''), replace(/\/filters/g, ''), replace(/\s/g, '-'));
export const sortTakeTwoJoinDash = compose(joinWithDashes, take(2), withSortLocale);

export const isSmartMatch = url => {

    return oneregex.test(fastNormalize(url));
};

const hasTaxonomyProperties = parsed => parsed.make || parsed.model || parsed.bodyStyle;

const translate = parsed => {
    let response = "cars/";
    response += parsed.make ? `${parsed.make}` : '';
    response += parsed.model ? `-${parsed.model}` : '';
    response += parsed.bodyStyle ? `-${parsed.bodyStyle}` : '';

    const hasTaxonomy = hasTaxonomyProperties(parsed);
    const hasNonTaxonomy = parsed.year || parsed.geo || (parsed.colors && parsed.colors.length <3);

    if (hasTaxonomy && hasNonTaxonomy) {
        response += '/';
    }

    response += parsed.year ? `${parsed.year}-` : '';

    if (parsed.colors && parsed.colors.length <3) {
        response += sortTakeTwoJoinDash(parsed.colors);
        response += '-';
    }

    response += parsed.geo ? `${parsed.geo}` : '';

    return fixUrl(response);
};

const verifyLength = regexResult => {
    if (regexResult.length !== expectedLength) {
        console.log('regex length error');
    }
};

const getRegexResult = url => {
    const regexResult = oneregex.exec(fastNormalize(url))

    verifyLength(regexResult);

    return regexResult;
};

const canIdentifyMake = makeonly => makeonly && !knownMakes.find(x=> `/${toLower(x)}`===makeonly);

export const smartTranslate = (url, skipValidation=false) => {
    if (skipValidation || isSmartMatch(url)) {
        const [, , bodyStyle , geo, , make, model, year, makeonly, colors='', , geo2, colors2=''] = getRegexResult(url);

        let verifiedMakeOnly = makeonly;

        if (canIdentifyMake(makeonly)) {
            verifiedMakeOnly = '';
        }

        const combinedColors = colors + colors2;

        const parsed = {
            ...((geo || geo2) && {geo: replace('/','',geo || geo2)}),
            ...((make || verifiedMakeOnly) && {make: replace('/','',make || verifiedMakeOnly)}),
            ...(model && {model}),
            ...(combinedColors && {colors: fixColors(combinedColors)}),
            ...(bodyStyle && {bodyStyle: fixBodystyles(bodyStyle)}),
            ...(year && {year: replace('/','',year)})
        };

        return {
            ...parsed,
            url: translate(parsed)
        }
    }

    return {url};
};
